import { schema } from "normalizr";
import { bureauxTypes } from "../types";
import Resource from "./resource";

const bureauSchema = new schema.Entity("bureaux");

export default new Resource("/bureaux", bureauxTypes, bureauSchema);
